export default __webpack_public_path__ + "static/media/site-logo.563c2ac6.svg";